import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { prepareStaffAccount } from "./authSlice";
import { performLogout } from "./performLogout";

export default function useStaffAccountPreparation() {
  const dispatch = useDispatch();
  const { accountStatus, accountError, user } = useSelector(
    (state) => state.auth,
  );
  useEffect(() => {
    if (user && accountStatus === "idle") dispatch(prepareStaffAccount());
  }, [dispatch, user, accountStatus]);
  const retry = useCallback(() => dispatch(prepareStaffAccount()), [dispatch]);
  const signOut = useCallback(() => performLogout(dispatch), [dispatch]);
  return { accountStatus, accountError, retry, signOut };
}
